export default __webpack_public_path__ + "locales/tr/MainBar.json?hash=d92c553b3882f67d2c5298fd9d11bb2a";